// extracted by mini-css-extract-plugin
module.exports = {"loader":"App_loader__1rCzy"};